<template>
  <div class="infra-divider mb-3 mb-lg-5">
    <div class="container-fluid p-0 pt-3 container-infra">
      <div class="col-9 col-lg-3 p-0">
        <svg version="1.1" class="component-svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 400 94" xml:space="preserve">
        <g>
          <polygon class="st0" points="393,91 0,91 0,9 336,9"></polygon>
        </g>
          <path class="st1" d="M340,11c9.72,13.51,19.34,27.1,28.99,40.66l14.43,20.37l14.39,20.41l1.08,1.54L397,93.99l-49.62,0.36
	l-49.62,0.17l-49.62,0.17l-49.63-0.04l-49.63-0.05l-49.63-0.23C66.17,94.22,33.08,93.93,0,93.5c33.08-0.52,66.17-0.88,99.25-1.11
	l49.62-0.36l49.62-0.17l49.62-0.17l49.63,0.05l49.63,0.05L397,92.01l-0.81,1.55l-14.11-20.59l-14.07-20.63
	C358.66,38.57,349.28,24.82,340,11z"></path>
          <text transform="matrix(1 0 0 1 58 64)" class="st2 st3 st4 text-uppercase"><slot></slot></text>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "InfraDivider"
  }
</script>

<style scoped lang="scss">
  .container-infra {
    // background-color: #e1e1e1;
  }

  .component-svg {
    filter: drop-shadow(2px 2px 3px #ff0000);
    margin-bottom: 8px;
  }

  .st0 {
    fill:#353535;
  }
  .st1{fill: #ff0000;}
  .st2{fill:#FFFFFF;}
  .st3{
    font-family:'Roboto', sans-serif;
    font-weight: bold;
  }
  .st4{font-size: 2.5em;}

</style>
